import { Component } from 'src/utils';
import template from './product-promo.html';
import promoImage from './../../../images/Artboard.png';

@Component({
  controllerAs: 'ctrl',
  template
})

export default class productPromo {

  static $inject = [
    '$scope',
    '$ngRedux',
    '$state',
    'authService',
    '$cookies',
    '$window'

  ];

  constructor($scope, $ngRedux, $state, $auth, $cookies, $window) {
    this.promoImage = promoImage;
    this.$window = $window;
    const disconnect = $ngRedux.connect(this.mapState)(this);
    $scope.$on('$destroy', disconnect);
  }

  mapState(state) {
    let obj = {
      profile: state.auth.profile,
      list: state.order.categories
    };
    if (!obj.profile.store) {
      obj.profile = {'store': state.auth.storeDetail};
    }
    return obj;
  }

  isIpad() {
   
    return ( this.$window.innerWidth < 1248 && this.$window.innerWidth > 767 );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/product-promo/product-promo.js